// decorators/field.ts
import {
  unwrapType,
  getArrayDepth
} from "../metadata/types.js";
import { fieldParentSymbol } from "../symbols.js";
function Field(type, options = {}) {
  return (target, propertyName) => {
    registerField(target, type, propertyName, options);
  };
}
var registerField = (target, type, propertyName, options, dynamic = false) => {
  let currentFields = target.fields;
  if (!currentFields) {
    currentFields = { [fieldParentSymbol]: target };
  }
  if (currentFields[fieldParentSymbol] !== target) {
    const parentFields = Object.fromEntries(
      Object.entries(currentFields).map(([key, value]) => [key, { ...value, fromParent: true }])
    );
    currentFields = { ...parentFields, [fieldParentSymbol]: target };
  }
  const unwrappedType = unwrapType(type);
  currentFields[propertyName] = {
    name: propertyName,
    type: unwrappedType,
    arrayDepth: getArrayDepth(type),
    options,
    params: [],
    middlewares: [],
    dynamic
  };
  target.fields = currentFields;
};
export {
  Field,
  registerField
};
